var app = {};

app.init = function () {
  app.hamburger();
  app.slider();
  app.dropdown();
  app.accessibleNavDropdown();
};

//Mobile Hamburger Menu
app.hamburger = function () {
  $(".hamburger").on("click", function () {
    let isNavOpen = $(".body-with-open-nav");

    if (isNavOpen.length > 0) {
      $(".header-mobile-wrapper").attr("aria-hidden", "true");
    } else {
      $(".header-mobile-wrapper").attr("aria-hidden", "false");
    }
    $(".hamburger").toggleClass("is-active");
    $("body").toggleClass("body-with-open-nav");
  });

  // Tabbing through last menu item closes the modal
  //
  //ATTN: IF THE HEADER CONTENT HAS BEEN CHANGED FROM STARTER THEME DEFAULT, CORRECT HTML SELECTOR AND BROWSER WIDTH AT WHICH HEADER SWITCHES TO MOBILE NEEDS TO BE EDITED HERE
  //
  // direct child selector is included to account for sub menus
  $(".header-primary-nav > li:last-child a").focusout(function () {
    let width = $(window).width();
    if (width < 993) {
      $(".header-mobile-wrapper").attr("aria-expanded", "false");
      $("body").removeClass("body-with-open-nav");
      $(".hamburger").toggleClass("is-active");
      $(".hamburger").focus();
    }
  });

  // Pressing on the escape key closes the mobile menu
  $(document).keyup(function (e) {
    if (e.key === "Escape") {
      if ($("body").hasClass("body-with-open-nav")) {
        $(".header-mobile-wrapper").attr("aria-expanded", "false");
        $("body").removeClass("body-with-open-nav");
        $(".hamburger").toggleClass("is-active");
        $(".hamburger").focus();
      }
    }
  });
};

// default slider with auto advance
app.slider = function () {
  if ($(".slider").length) {
    var slideIndex = 0;
    showSlides(slideIndex);

    function plusSlides(n) {
      showSlides((slideIndex += n));
    }

    function autoAdvance() {
      plusSlides(1);
    }

    autoAdvance();

    var timerId = setInterval(autoAdvance, 9000);

    $(".slider-prev").click(function () {
      plusSlides(-1);
      clearInterval(timerId);
    });
    $(".slider-next").click(function () {
      plusSlides(1);
      clearInterval(timerId);
    });
    $(".pause-slideshow").on("click", function () {
      clearInterval(timerId);
      $(this).css("display", "none");
      $(".play-slideshow").css("display", "flex");
    });
    $(".play-slideshow").on("click", function () {
      plusSlides(1);
      timerId = setInterval(autoAdvance, 9000);
      $(this).css("display", "none");
      $(".pause-slideshow").css("display", "flex");
    });

    function showSlides(n) {
      var i;
      var x = document.getElementsByClassName("hero-slides");
      if (n > x.length) {
        slideIndex = 1;
      }
      if (n < 1) {
        slideIndex = x.length;
      }
      for (i = 0; i < x.length; i++) {
        x[i].style.display = "none";
      }
      x[slideIndex - 1].style.display = "block";
    }

    //If only one slide exists, don't show the prev + next + pause buttons
    const slides = document.querySelectorAll(".hero-slides");
    if (slides.length < 2) {
      $(".slider-button").css("display", "none");
    }
  }
};

app.dropdown = function () {
  //dropdown general functionality
  $(".dropdown").click(function () {
    if ($(this).hasClass("button-with-open-content")) {
      $(this).next(".dropdown-content").removeClass("dropdown-is-open");
      $(this).attr("aria-expanded", "false");
      $(this).removeClass("button-with-open-content");
    } else {
      $(this).next(".dropdown-content").addClass("dropdown-is-open");
      $(this).attr("aria-expanded", "true");
      $(this).addClass("button-with-open-content");
    }
  });
};

app.accessibleNavDropdown = function () {
  $(".menu-item-has-children>a")
    .attr("aria-haspopup", "true")
    .attr("aria-expanded", "false");

  $(".menu-item-has-children").on("mouseenter focusin", function () {
    $(".menu-item-has-children>a").attr("aria-expanded", "true");
  });

  $(".menu-item-has-children").on("mouseleave focusout", function () {
    $(".menu-item-has-children>a").attr("aria-expanded", "false");
  });
};

$(document).ready(function () {
  //call all the app functions
  app.init();
});
